<div class="card custom-question__container">
  <div
    class="d-flex align-items-center justify-content-between default-s mb12 custom-question__header"
  >
    <div>{{ customQuestion()?.title }}</div>
    <div im-dropdown position="block-end" (click)="$event.stopPropagation()">
      <button
        im-icon-button
        imDropdownTrigger
        [attr.aria-label]="'general.more_actions_a' | translate"
      >
        <i class="icon icon--context"></i>
      </button>
      <div imDropdownMenu>
        <div imDropdownGroup>
          @if (showPreview()) {
            <button imDropdownItem (click)="onPreview()">
              {{ 'custom_questions.preview_a' | translate }}
            </button>
          }
          <button imDropdownItem (click)="onDelete()">
            {{ 'custom_questions.delete_a' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <app-custom-question-details
    [customQuestion]="customQuestion()"
  ></app-custom-question-details>
</div>
